<template>
  <div class="columns is-multiline">
    <div class="column is-12 has-text-primary is-italic is-size-5">
      {{ $t('addEditOrdreTravailTech.patrimoine.dispositif.champs.title') }}
    </div>
    <b-field :label="$t('addEditOrdreTravailTech.patrimoine.dispositif.champs.couleurRal')"
             class="column is-3 mgb-0 pdt-0">
      <b-input v-model="dispositifTechnique.couleurRAL"></b-input>
    </b-field>
    <b-field
      :label="$t('addEditOrdreTravailTech.patrimoine.dispositif.champs.restrictionsAffichage')"
      class="column is-3 mgb-0 pdt-0">
      <b-input v-model="dispositifTechnique.restrictionsAffichage"></b-input>
    </b-field>
    <b-field
      :label="$t('addEditOrdreTravailTech.patrimoine.dispositif.champs.valeurAcquisition')"
      class="column is-3 mgb-0 pdt-0">
      <input-currency v-model="dispositifTechnique.valeurAcquisition">
      </input-currency>
    </b-field>
    <b-field
      :label="$t('addEditOrdreTravailTech.patrimoine.dispositif.champs.longueur')"
      class="column is-3 mgb-0 pdt-0">
      <input-currency v-model="dispositifTechnique.longueur">
      </input-currency>
    </b-field>
    <b-field
      :label="$t('addEditOrdreTravailTech.patrimoine.dispositif.champs.publicitaire')"
      class="column is-3 mgb-0 pdt-0">
      <b-checkbox v-model="dispositifTechnique.publicitaire"></b-checkbox>
    </b-field>
    <b-field :label="$t('addEditOrdreTravailTech.patrimoine.dispositif.champs.particularite')"
             class="column is-3 mgb-0 pdt-0">
      <b-input v-model="dispositifTechnique.particularite"></b-input>
    </b-field>
    <b-field
      :label="$t('addEditOrdreTravailTech.patrimoine.dispositif.champs.largeurToit')"
      class="column is-3 mgb-0 pdt-0">
      <input-currency v-model="dispositifTechnique.largeurToit">
      </input-currency>
    </b-field>
    <b-field
      :label="$t('addEditOrdreTravailTech.patrimoine.dispositif.champs.eclairable')"
      class="column is-3 mgb-0 pdt-0">
      <b-checkbox v-model="dispositifTechnique.eclairable"></b-checkbox>
    </b-field>
    <b-field
      :label="$t('addEditOrdreTravailTech.patrimoine.dispositif.champs.planRecollement')"
      class="column is-3 mgb-0 pdt-0">
      <b-input v-model="dispositifTechnique.planRecollement"></b-input>
    </b-field>
    <b-field
      :label="$t('addEditOrdreTravailTech.patrimoine.dispositif.champs.cableEdfProx')"
      class="column is-3 mgb-0 pdt-0">
      <b-checkbox v-model="dispositifTechnique.cableEdfProx"></b-checkbox>
    </b-field>
    <b-field
      :label="$t('addEditOrdreTravailTech.patrimoine.dispositif.champs.distanceEnMCablesEdf')"
      class="column is-3 mgb-0 pdt-0">
      <input-currency v-model="dispositifTechnique.distanceEnMCablesEdf">
      </input-currency>
    </b-field>
    <b-field
      :label="$t('addEditOrdreTravailTech.patrimoine.dispositif.champs.hauteurSousPanneau')"
      class="column is-3 mgb-0 pdt-0">
      <input-currency v-model="dispositifTechnique.hauteurSousPanneau">
      </input-currency>
    </b-field>
    <b-field
      :label="$t('addEditOrdreTravailTech.patrimoine.dispositif.champs.nacelleNecessaire')"
      class="column is-3 mgb-0 pdt-0">
      <b-checkbox v-model="dispositifTechnique.nacelleNecessaire"></b-checkbox>
    </b-field>
    <b-field
      :label="$t('addEditOrdreTravailTech.patrimoine.dispositif.champs.grueNecessaire')"
      class="column is-3 mgb-0 pdt-0">
      <b-checkbox v-model="dispositifTechnique.grueNecessaire"></b-checkbox>
    </b-field>
    <b-field
      :label="$t('addEditOrdreTravailTech.patrimoine.dispositif.champs.echelleNecessaire')"
      class="column is-3 mgb-0 pdt-0">
      <b-checkbox v-model="dispositifTechnique.echelleNecessaire"></b-checkbox>
    </b-field>
    <b-field
      :label="$t('addEditOrdreTravailTech.patrimoine.dispositif.champs.autreEquipementNecessaire')"
      class="column is-3 mgb-0 pdt-0">
      <b-input v-model="dispositifTechnique.autreEquipementNecessaire"></b-input>
    </b-field>
    <b-field
      :label="$t('addEditOrdreTravailTech.patrimoine.dispositif.champs.obstacle')"
      class="column is-3 mgb-0 pdt-0">
      <b-input v-model="dispositifTechnique.obstacle"></b-input>
    </b-field>
    <b-field
      :label="$t('addEditOrdreTravailTech.patrimoine.dispositif.champs.fournisseurElectricite')"
      class="column is-3 mgb-0 pdt-0">
      <b-autocomplete
        allow-new
        v-model="fournisseurSelect"
        :data="fournisseurs"
        field="nomCommercial"
        open-on-focus
        @typing="getFournisseurs"
        :loading="isFetchingFournisseur"
        @select="fournisseur => selectFournisseur(fournisseur)">
        <template slot="empty">
          <div v-if="!isFetchingFournisseur">
            {{$t('general.autocomplete.noRslt')}}
          </div>
          <div v-else>
            {{$t('general.autocomplete.search')}}
          </div>
        </template>
      </b-autocomplete>
    </b-field>
    <b-field
      :label="$t('addEditOrdreTravailTech.patrimoine.dispositif.champs.tiersProprietaire')"
      class="column is-3 mgb-0 pdt-0">
      <b-autocomplete
        allow-new
        v-model="tiersSelect"
        :data="tiers"
        field="nomCommercial"
        open-on-focus
        @typing="getTiers"
        :loading="isFetchingTiers"
        @select="dataTiers => selectTiers(dataTiers)">
        <template slot="empty">
          <div v-if="!isFetchingTiers">
            {{$t('general.autocomplete.noRslt')}}
          </div>
          <div v-else>
            {{$t('general.autocomplete.search')}}
          </div>
        </template>
      </b-autocomplete>
    </b-field>
    <b-field
      :label="$t('addEditOrdreTravailTech.patrimoine.dispositif.champs.accessoires.title')"
      class="column is-6 mgb-0">
      <b-table :data="otPatrimoineAccessoires" :bordered="true" :striped="true">
        <b-table-column
          header-class="has-text-default"
          field="libelle"
          v-slot="props"
          :label="$t('addEditOrdreTravailTech.patrimoine.dispositif.champs.accessoires.libelle')">
          <parametre-autocomplete
            v-model="props.row.accessoireId"
            :target="constantes.PARAMETRES_KEYS.accessoire"
            :custom-map-item="(item) => ({
              ...item,
              libelleComplet: [
                item.libelle,
                item.fournisseur ? item.fournisseur.nomCommercial : '',
              ].filter(Boolean).join(' - '),
            })"
            field="libelleComplet"
            expanded
          />
        </b-table-column>
        <b-table-column
          header-class="has-text-default"
          field="quantite"
          v-slot="props"
          :label="$t('addEditOrdreTravailTech.patrimoine.dispositif.champs.accessoires.quantite')">
          <b-input v-model="props.row.quantite" type="number"></b-input>
        </b-table-column>
        <b-table-column v-slot="props">
          <div class="has-text-centered mgt-5px is-cursor-pointer"
               @click="deleteAccessoire(props.index)">
            <b-icon type="is-danger"
                    icon="delete-forever">
            </b-icon>
          </div>
        </b-table-column>
        <template #empty>
          {{ $t('general.autocomplete.noRslt')}}
        </template>
        <template #footer>
          <div class="has-text-right">
            <button
              class="button is-primary"
              @click="addAccessoire()">
              {{ $t('addEditOrdreTravailTech.patrimoine.dispositif.champs.accessoires.add') }}
            </button>
          </div>
        </template>
      </b-table>
    </b-field>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import inputCurrency from '@/components/general/inputCurrency';
import { getAll } from '@/api/tiers';
import debounce from 'lodash/debounce';
import messageErreur from '@/services/general/messageErreur';
import { TIERS_TYPE_FOURNISSEUR } from '@/configuration/tiers/tiersConf';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import ParametreAutocomplete from '@/components/general/autocomplete/parametreAutocomplete';
import genererAccessoireOTPatrimoine
  from '@/services/logistique/ordreTravail/tech/genererObject/genererAccessoireOT';

export default {
  props: {
    dispositifTechnique: {
      type: Object,
      required: true,
    },
    societeId: {
      type: String,
      required: true,
    },
    otPatrimoineAccessoires: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      fournisseurs: [],
      isFetchingFournisseur: false,
      fournisseurSelect: null,
      tiers: [],
      isFetchingTiers: false,
      tiersSelect: null,
      constantes: {
        PARAMETRES_KEYS,
      },
    };
  },
  components: {
    ParametreAutocomplete,
    inputCurrency,
  },
  methods: {
    deleteAccessoire(index) {
      this.otPatrimoineAccessoires.splice(index, 1);
    },
    addAccessoire() {
      this.otPatrimoineAccessoires.push(cloneDeep(genererAccessoireOTPatrimoine()));
    },
    selectFournisseur(newFournisseur) {
      if (!newFournisseur) return;
      this.fournisseurSelect = newFournisseur.nomCommercial;
      this.dispositifTechnique.fournisseurElectriciteId = newFournisseur.id;
    },
    selectTiers(newTiers) {
      if (!newTiers) return;
      this.tiersSelect = newTiers.nomCommercial;
      this.dispositifTechnique.tiersProprietaireId = newTiers.id;
    },
    getFournisseurs: debounce(async function fournisseurData(text) {
      try {
        if (text === undefined) return;
        this.fournisseurs = [];
        this.isFetchingFournisseur = true;
        this.dispositifTechnique.fournisseurElectriciteId = null;
        this.dispositifTechnique.fournisseurElectricite = null;
        this.fournisseurs = (await getAll({
          query: {
            auto: text,
            societeId: this.societeId,
            type: TIERS_TYPE_FOURNISSEUR,
          },
          limit: NO_PAGINATION,
        })).data.result.items;
        this.isFetchingFournisseur = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetchingFournisseur = false;
        throw e;
      }
    }, 500),
    getTiers: debounce(async function tiersData(text) {
      try {
        if (text === undefined) return;
        this.tiers = [];
        this.isFetchingTiers = true;
        this.dispositifTechnique.tiersProprietaireId = null;
        this.dispositifTechnique.tiersProprietaire = null;
        this.tiers = (await getAll({
          query: {
            auto: text,
            societeId: this.societeId,
          },
          limit: NO_PAGINATION,
        })).data.result.items;
        this.isFetchingTiers = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetchingTiers = false;
        throw e;
      }
    }, 500),
    listeAccessoires(id) {
      return this.accessoires.filter((acc) => {
        return acc.actif || acc.id === id;
      });
    },
  },
  async mounted() {
    try {
      await this.getFournisseurs();
      await this.getTiers();
      this.fournisseurSelect = this.dispositifTechnique.fournisseurElectricite
        ? this.dispositifTechnique.fournisseurElectricite.nomCommercial : null;
      this.tiersSelect = this.dispositifTechnique.tiersProprietaire
        ? this.dispositifTechnique.tiersProprietaire.nomCommercial : null;
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    }
  },
};

</script>
